import { render, staticRenderFns } from "./ActorsDetail.vue?vue&type=template&id=c5143aac&scoped=true&"
import script from "./ActorsDetail.vue?vue&type=script&lang=ts&"
export * from "./ActorsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ActorsDetail.vue?vue&type=style&index=0&id=c5143aac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5143aac",
  null
  
)

export default component.exports